import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import cx from "classnames";

const validInputs = ["input", "textarea", "select"];

const FormGroup = ({
	children,
	t,
	label,
	labelClassName,
	srLabel,
	htmlFor,
	help,
	valid,
	feedback,
}) => {
	let inputId;
	if (!htmlFor) {
		children = React.Children.map(children, child => {
			if (child && validInputs.includes(child.type)) {
				inputId = child.props.id || child.props.name;
				htmlFor = inputId;
				return React.cloneElement(child, {
					id: inputId,
				});
			}
		});
	}

	return (
		<div
			className={cx("form-group", {
				"has-success": valid,
				"has-danger": valid === false,
			})}
		>
			<label
				htmlFor={htmlFor}
				className={cx({
					"sr-only": srLabel,
					"form-control-label": !labelClassName,
					[labelClassName]: labelClassName,
				})}
			>
				{t(label)}
			</label>
			{children}
			{feedback && <div className="form-control-feedback">{t(feedback)}</div>}
			{help && <small className="form-text">{t(help)}</small>}
		</div>
	);
};

FormGroup.propTypes = {
	children: PropTypes.node.isRequired,
	t: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
	labelClassName: PropTypes.string,
	srLabel: PropTypes.bool,
	htmlFor: PropTypes.string,
	help: PropTypes.string,
	valid: PropTypes.bool,
	feedback: PropTypes.string,
};

export { FormGroup };
export default translate()(FormGroup);



// WEBPACK FOOTER //
// ./src/components/FormGroup.js